import { FormTemplateQuestionFieldOptionGroupEnum } from 'graphql-common';

export default function removeValidityHintConfigItem(
  position: number,
  group: FormTemplateQuestionFieldOptionGroupEnum,
  validityHintConfig: object,
) {
  const newConfig = {};
  Object.entries(validityHintConfig).forEach(([key, value]) => {
    const [rowIndex, columnIndex] = key.split('-').map(Number);
    if (
      group === FormTemplateQuestionFieldOptionGroupEnum.Rows &&
      rowIndex !== position
    ) {
      newConfig[key] = value;
    } else if (
      group === FormTemplateQuestionFieldOptionGroupEnum.Columns &&
      columnIndex !== position
    ) {
      newConfig[key] = value;
    }
  });
  return newConfig;
}
